import {isFumigationFinding} from './repairFindingGroups';

export function followsDiagramArea(finding){
  return !finding.fumeVolumeEstimate && !finding.fumeMeasuredVal && finding.fumeSqftSource!=='manual'
    && !(Number(finding.fumeCubicFt)>0&&!Number(finding.fumeHeightFt));
}

// Update every linked finding together so one row cannot restore another row's
// stale volume. Explicit measurements and reviewed multi-section estimates stay put.
export function syncDiagramAreas(findings,area,priceForVolume){
  if(!Number.isFinite(area)||area<0)return findings;
  let changed=false;
  const next=(findings||[]).map(f=>{
    if(!isFumigationFinding(f)||!followsDiagramArea(f))return f;
    const sqft=area>0?String(area):'';
    const height=Number(f.fumeHeightFt)||0;
    const cubicFt=height>0?Math.round(area*height):0;
    const volumeChanged=Number(f.fumeSqft)!==area||f.fumeCubicFt!==cubicFt;
    const price=volumeChanged&&height>0&&priceForVolume?priceForVolume(f,cubicFt):f.primaryPrice;
    if(f.fumeSqft===sqft&&f.fumeSqftSource==='diagram'&&f.fumeCubicFt===cubicFt&&f.primaryPrice===price)return f;
    changed=true;
    return {...f,fumeSqft:sqft,fumeSqftSource:'diagram',fumeCubicFt:cubicFt,primaryPrice:price};
  });
  return changed?next:findings;
}
